export default "__VITE_ASSET__e2daf32f__"